import React from "react";
import ListCard from "../../../../components/ListCard/ListCard";
import Avatar from "../../../../components/Avatar/Avatar";
import IconButton from "../../../../components/IconButton/IconButton";

export type GroupCardProps = {
  id: string;
  name: string;
  description?: string | null;
  usersCount: number;
  permissionsCount: number;
  iconClassName?: string;
  imageUrl?: string | null;
  accentColor?: string;
  usersLabel: string;
  permissionsLabel: string;
  editLabel: string;
  permissionsButtonLabel: string;
  onEdit: (id: string) => void;
  onManagePermissions: (id: string) => void;
  className?: string;
};

const GroupCard: React.FC<GroupCardProps> = ({
  id,
  name,
  description,
  usersCount,
  permissionsCount,
  imageUrl,
  usersLabel,
  permissionsLabel,
  editLabel,
  permissionsButtonLabel,
  onEdit,
  onManagePermissions,
  className,
}) => {
  const sanitizedDescription = description?.trim() ?? "";
  const hasDescription = sanitizedDescription.length > 0;

  return (
    <ListCard className={className}>
      <ListCard.Header
        title={name}
        avatar={
          <Avatar
            type="entity"
            name={name}
            image={imageUrl || undefined}
          />
        }
      />
      
      <ListCard.Content>
        {hasDescription && (
          <ListCard.Description>{sanitizedDescription}</ListCard.Description>
        )}
        
        <ListCard.Metadata layout="inline">
          <ListCard.Metadata.Item icon="group" label={usersLabel} value={usersCount} />
          <ListCard.Metadata.Item icon="lock" label={permissionsLabel} value={permissionsCount} />
        </ListCard.Metadata>
      </ListCard.Content>

      <ListCard.Footer alignment="end" divider>
        <IconButton
          icon="edit"
          variant="text"
          severity="secondary"
          aria-label={editLabel}
          onClick={() => onEdit(id)}
        />
        <IconButton
          icon="lock"
          variant="text"
          severity="primary"
          aria-label={permissionsButtonLabel}
          onClick={() => onManagePermissions(id)}
        />
      </ListCard.Footer>
    </ListCard>
  );
};

export default React.memo(GroupCard);
